import { PortMarocService } from './../Service/port-maroc.service';
import { RechercheService } from './../Service/recherche.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from './../Service/shared.service';
import { Global } from 'src/app/Service/global.service';
import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { sp, Web} from "@pnp/sp/presets/all";
import { ICamlQuery } from "@pnp/sp/lists";

@Component({
  selector: 'app-recherche',
  templateUrl: './recherche.component.html',
  styleUrls: ['./recherche.component.scss']
})
export class RechercheComponent implements OnInit {

  constructor(private global:Global, private searchService: RechercheService,private portService: PortMarocService,
    private router: Router, private aroute:ActivatedRoute) { 
      sp.setup({
        sp:{
          baseUrl: this.global._basedUrl
        }
      })
    }
currentLg = '';
currentUrl ='';
searchInput = ''; 
libraryList = [];
customList = [];
configRecherche = [];
dataShow = [];
results = [];
indexCharger = 1;
resultsShow = [];
portMenuData = [];
isArab=false;
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(
      takeUntil(this.global.navigationEnd)
    ).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.currentLg = lg.code;
      this.currentUrl = lg.url;
      forkJoin([this.searchService.getParamRecherche(), this.searchService.getRechercheContenu(), this.portService.getMenuData()]).subscribe(datas => { 
        //@ts-ignore
        const contenus = datas[1].value
        //@ts-ignore
        this.portMenuData = datas[2].value
        let index =  0;
        //@ts-ignore
        datas[0].value.forEach(element => {
          index++;
          const item = this.getContenuById(element.ListeId, contenus);
          const champs = element.ChampsRecherchable  !== null  && element.ChampsRecherchable  !== '' ?   this.returnChamps(element.ChampsRecherchable,'Name') : '';
          const champsType = element.ChampsRecherchable  !== null  && element.ChampsRecherchable  !== '' ?   this.returnChamps(element.ChampsRecherchable,'Type') : '';
        const  obj=  {
          Title: item.Title,
          InternalName: item.InternalName,
          TypeListe : item.TypeListe,
          ApplicationUrl: item.ApplicationUrl,
          Langue : item.Langue,
          Ports: item.Ports, 
          BadgeFr: item.BadgeFr, 
          BadgeEn: item.BadgeEn, 
          BadgeAr: item.BadgeAr, 
          Affichable: item.Affichable, 
          Champs: champs,
          ChampsBrute :element.ChampsRecherchable ,
          ChampsType:champsType,
          ResultsTitre: element.TitreResult  !== null  && element.TitreResult  !== '' ? this.returnField(element.TitreResult).Name : '',
          ResultsDescription:element.DescriptionResult  !== null  && element.DescriptionResult  !== '' ? this.returnField(element.DescriptionResult).Name : '',
          ResultsTitreType: element.TitreResult  !== null  && element.TitreResult  !== '' ? this.returnField(element.TitreResult).Type : '',
          ResultsDescriptionType:element.DescriptionResult  !== null  && element.DescriptionResult  !== '' ? this.returnField(element.DescriptionResult).Type : '',
          Id: element.Id, 
          IdContenu: element.ListeId, 
          index: index
        }
        if(obj.Langue.indexOf(this.currentLg.toUpperCase()) !== -1)  {
        
        obj.TypeListe !== 'Liste' ? this.libraryList.push(obj) : this.customList.push(obj);
        }
        });
        this.aroute.queryParams.subscribe(datas => {
          console.log(datas);
          if(datas.search !== undefined && datas.search !=='' && datas.search !== null) {
            if(datas.search.length > 3) {
              this.searchInput = datas.search;
              this.Search(datas.search)
            } else {
              alert('Merci de sasir au moins 3 caractères')
            }
          }
        })
        
      })
    });
  }
  getContenuById(id, contenus) {
    let obj = null;
    contenus.forEach(item => {
      if(id === item.Id) {
        obj = {
          Title : item.Title,
          InternalName: item.InternalName,
          TypeListe : item.TypeListe,
          ApplicationUrl: item.ApplicationUrl,
          Langue : item.Langue,
          Ports: item.Ports, 
          BadgeFr: item.Badge, 
          BadgeEn: item.BadgeEn, 
          BadgeAr: item.BadgeAr, 
          Affichable: item.Affichable, 
        }
      }
    });
    return obj
  }
  returnChamps(champs, Type) {
  
   let fields = '';
    champs.split(',').forEach(element => {
      this.returnField(element)[Type]
      if(fields ==='') {
        fields =  (this.returnField(element))[Type];
      } else {
        fields +=  ',' + (this.returnField(element))[Type];
      }
    });
    return fields;
  }
  returnField(field) {
    const champ = new Field();
    champ.Type = field.split(':')[1];
    champ.Name = field.split(':')[0];
    return champ
  }
  searchClicked() {
    this.router.navigate(['/recherche'],  { queryParams: {search: this.searchInput} })
  }
  Search(input){
    this.results = [];
    this.resultsShow = [];
    if(input !== null && input.length > 2) {
     const requetes = this.createRequest(input);
     //@ts-ignore
     forkJoin(requetes).subscribe(datas => {
     let index = 0;
     datas.forEach(results => {
  
       const config =   index < this.libraryList.length ? this.libraryList[index] : this.customList[index -this.libraryList.length ];
      if(index < this.libraryList.length) {
     //@ts-ignore
     const dataValue = results !== [] ? results.PrimaryQueryResult.RelevantResults.Table.Rows : [];
     dataValue.forEach(item => {
     const obj = this.getRechercheItem(item,config);
    obj !== null ? this.results.push( obj) : '';
     });
      } else {
        //@ts-ignore
        results.forEach(item => {
          const obj = {
          Title : item[config.ResultsTitre], 
          Description :  config.ResultsDescription !== '' && config.ResultsDescription !== null ? item[config.ResultsDescription] : '',
          Type:'api', 
          badge: this.currentLg === 'fr' ? config.BadgeFr :  this.currentLg === 'ar'  ?  config.BadgeAr : config.BadgeEn, 
          ApplicationUrl : ['/' + config.ApplicationUrl , item.Id], 
          DateCreation: new Date(item.Created)
          }
          this.results.push( obj);
          });
        
      }
      index++;
  
     });
    this.results  = this.results.sort(function(a,b){
      return b.DateCreation - a.DateCreation;
    });
    console.log(this.results)
    this.indexCharger = 1;
   this.resultsShow = this.results.slice(0,25);

    
    });
    } else {
      alert('Merci de saisir au moins 3 caractères')
    }
  }
  chargerPlus() {
    this.indexCharger++;
    this.resultsShow = this.results.slice(0,25*this.indexCharger);
  }
  titleDescription(field, length) {
    
    if(field !== null && field !== undefined && field.length > length ) {
      return field.toString().replace(/<[^>]*>/g, '').substring(0,length) + '...'
    } else {
      return field ? field.replace(/<[^>]*>/g, '') : ''
    }
}
  getRechercheItem(item, config) {
    let obj = null;
    let id = '';
    let url = '';
    let type ='';
    let Title ='';
    let dateCreation ;
    if(item !== undefined && item !== null) {
    item.Cells.forEach(element => {
   
      if(element.Key === 'Title')
      {
        Title = element.Value
      }
      if(element.Key === 'OriginalPath')
      {
        url = element.Value
      }
      if(element.Key === 'ListItemID')
      {
        id = element.Value
      }
      if(element.Key === 'FileExtension')
      {
        type = element.Value
      }
      if(element.Key === 'created')
      {
        dateCreation = new Date(element.Value);
      }
      
    });

           obj = {
        id : id,
        url: url,
        format: type,
        Titre: Title, 
        Affichable : config.Affichable,
        TitreRecherche : config.Title, 
        listName: config.Title,
        Ports : config.Ports, 
        badge: this.currentLg === 'fr' ? config.BadgeFr :  this.currentLg === 'ar'  ?  config.BadgeAr : config.BadgeEn, 
        Type : 'Recherche', 
        DateCreation: dateCreation
      }

    }
     return obj
  } 

  getServicePortUrl(id, listName){
    this.searchService.getServicePortPageId( this.global._baseUrlStatique + '/Services/' + this.currentLg + '/' ,listName, id).subscribe(datas => {
      if(datas['value'].length > 0) {
        let linkApp = ''
        this.portMenuData.forEach(element => {
          if(element.ListeReference === listName) {
            linkApp = element.ApplicationUrl;
          }
        })
        const port = datas['value'][0].CodePort.toLowerCase().split('ports.port')[1];
        const url = "/services/port/" + port + "/page/" + linkApp
        this.router.navigate([url]);
      }
      
    })
  } 
  getPageStatiqueUrl(id) {
    
    this.searchService.getPageStatiqueById(this.currentUrl ,id).subscribe(datas => {
      if(datas['value'].length > 0) {
        let section = datas['value'][0].Section
        let url = ''
           if ( section.toLowerCase() === 'agence') {
              url  = '/agence/'
            } else if (section.toLowerCase() === 'grands chantiers') {
              url = '/grands-chantiers/';
            } else if (section.toLowerCase() === 'missions') {    
              url ='/missions/'
            } else if (section.toLowerCase() === 'formation portuaire') {
              url = '/formation-portuaire/'
            } else if (section.toLowerCase() === 'services') {
              url = '/services/'
            } else if (section.toLowerCase() === 'publications') {
              url = '/publications/';
            } else if (section.toLowerCase() === 'espace professionnel') {
              url= '/espace-professionnel/'
            }
            url = url  + datas['value'][0].FileLeafRef.split('.')[0]
            this.router.navigate([url])
      }
     
    })
  }

  createRequest(input){
    const requetes = []
    this.libraryList.forEach(element => {
     
          let  url = ''
          if(!element.Ports) {
            url = this.currentUrl + '/' + element.InternalName  + '/'
           
          } else {
            const lg = this.currentLg.toLowerCase() === 'fr' ? 'fr' : this.currentLg.toLocaleLowerCase() === 'ar' ? 'ar' :'en'
              url = this.global._baseUrlStatique + '/Services/' + lg + '/'  + element.InternalName  + '/'
          }
          url = url.replace(this.global._basedUrl,this.global._baseUrlStatique)
          url =encodeURIComponent(url);
       
          requetes.push(this.searchService.searchBibliotheque(url,input));
        
    }); 
    this.customList.forEach(element => {
        requetes.push(this.createCamlQuery(element, input));
    
    });
 return requetes;
  }

  createCamlQuery(config, key) {
   const champs = config.ChampsBrute

    let camlquery = ''
    
    champs.split(',').forEach(champ => {

       if(camlquery === '') {
        camlquery = "<Contains><FieldRef Name='"+ champ.split(':')[0] + "'/><Value Type='"+ champ.split(':')[1] + "'>"+ key + "</Value></Contains>"
    } else {
      camlquery = "<Or>" + camlquery + "<Contains><FieldRef Name='"+ champ.split(':')[0] + "'/><Value Type='"+ champ.split(':')[1] + "'>"+ key + "</Value></Contains>" + "</Or>"
    }
    });
    camlquery = "<View><Query><Where>"  +  camlquery + "</Where></Query></View>"
  
    const caml: ICamlQuery = {
      ViewXml: camlquery
  };
   return Web(this.currentUrl).lists.getByTitle( config.Title ).getItemsByCAMLQuery(caml)

  }
  converteDate(d: Date) {

    return d?this.global.formattedDate(d.toISOString()):"";
  }

}

class Field {
  public Name : string = '';
  public Type : string = '';

}
